import { motion } from "framer-motion";
import { Phone, MapPin, Clock, Star, Navigation } from "lucide-react";
import { PRACTICE } from "@/data/practice";

export const ContactFooter = () => {
  return (
    <footer
      id="contact"
      data-testid="contact-footer"
      className="bg-[#E3E7E0] pt-20 sm:pt-24 pb-10 relative grain-overlay"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-3xl mx-auto"
        >
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#3F9E8E] mb-4">
            Contact & rendez-vous
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#2C362B] leading-tight">
            Besoin de soins ? Appelez-nous
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#4A554A]">
            Notre équipe vous répond et organise votre prise en charge rapidement.
          </p>

          <a
            href={`tel:${PRACTICE.phoneRaw}`}
            data-testid="footer-call-button"
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#3F9E8E] text-white font-medium text-xl sm:text-2xl px-8 sm:px-10 py-5 shadow-lg hover:bg-[#348275] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
          >
            <Phone className="w-6 h-6" strokeWidth={2} />
            {PRACTICE.phone}
          </a>
        </motion.div>

        <div className="mt-16 grid sm:grid-cols-3 gap-6">
          <div className="bg-white rounded-2xl p-6 border border-white/60 shadow-sm">
            <MapPin className="w-6 h-6 text-[#3F9E8E] mb-3" strokeWidth={1.5} />
            <h3 className="font-semibold text-[#2C362B] mb-1">Adresse</h3>
            <p className="text-sm text-[#4A554A]">{PRACTICE.addressStreet}</p>
            <p className="text-sm text-[#4A554A]">{PRACTICE.addressCity}</p>
            <a
              href={PRACTICE.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-maps-link"
              className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[#3F9E8E] hover:gap-2.5 transition-[gap] duration-200"
            >
              <Navigation className="w-4 h-4" strokeWidth={2} />
              Itinéraire
            </a>
          </div>

          <div className="bg-white rounded-2xl p-6 border border-white/60 shadow-sm">
            <Clock className="w-6 h-6 text-[#3F9E8E] mb-3" strokeWidth={1.5} />
            <h3 className="font-semibold text-[#2C362B] mb-1">Horaires</h3>
            <p className="text-sm text-[#4A554A]">Tous les jours</p>
            <p className="text-sm text-[#4A554A]">8h00 – 20h00</p>
            <p className="mt-3 text-sm text-[#7C877C]">Soins à domicile & au cabinet</p>
          </div>

          <div className="bg-white rounded-2xl p-6 border border-white/60 shadow-sm">
            <Star className="w-6 h-6 text-[#E8B04B] fill-[#E8B04B] mb-3" strokeWidth={0} />
            <h3 className="font-semibold text-[#2C362B] mb-1">Avis Google</h3>
            <p className="text-sm text-[#4A554A]">{PRACTICE.rating} / 5 · {PRACTICE.reviewCount} avis</p>
            <p className="mt-3 text-sm text-[#7C877C]">
              « Soins à domicile et au cabinet sur RDV. »
            </p>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-[#C9CFC6]/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          <div>
            <p className="font-display font-bold text-[#2C362B]">
              {PRACTICE.fullName}
            </p>
            <p className="text-sm text-[#7C877C] mt-1">
              {PRACTICE.nurses} · Infirmiers libéraux D.E.
            </p>
          </div>
          <p className="text-xs text-[#7C877C]">
            © {new Date().getFullYear()} · cabinet-infirmier-bordeaux-victoire-capucins.fr
          </p>
        </div>
      </div>
    </footer>
  );
};
